import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SESSION_FEATURE_KEY, SessionsState} from "./session.reducer";

export const getSessionState = createFeatureSelector<SessionsState>(SESSION_FEATURE_KEY);
export const getSession = createSelector(getSessionState, (state) => state.session);
